module.exports = "<div class=\"overlay\"\n     [hidden]=\"hidden\"\n     [@visibilityChanged]=\"animationState\"\n     (@visibilityChanged.done)=\"animationDone()\"\n     (@visibilityChanged.start)=\"animationStart()\">\n  <div class=\"blackout\" (click)=\"close()\"></div>\n  <div class=\"modal\">\n    <button class=\"close\" (click)=\"close()\"></button>\n    <ng-content></ng-content>\n  </div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// /srv/projects/jsapp/src/app/shared/modal/modal.component.html
// module id = CUqy
// module chunks = 6